export default {
  'notificationsMappingAttachments.title': 'Notifications / Attached Mappings',

  'notificationsMappingAttachments.form.source': 'Origin Attachment',
  'notificationsMappingAttachments.form.attachmentName': 'Attachment Name',
  'notificationsMappingAttachments.form.select.FormFieldAttachment': 'Form / Field Attachment',
  'notificationsMappingAttachments.form.select.GeneratedDocument': 'Generated Document',
  'notificationsMappingAttachments.form.select.VariableAttachment': 'Variable / Attachment Type',

  'notificationsMappingAttachments.form': 'Form',
  'notificationsMappingAttachments.field': 'Field',
  'customNotifications.form.PDFTemplate': 'PDF Template',
  'customNotifications.form.Template': 'Template',
  'customNotifications.form.variable': 'Variable',
};
